module.exports = __webpack_public_path__ + "img/naked-insurance-banner-square-1.a1f16eff.jpg";